import {
  IText,
  Point,
} from "fabric";

// HACK: On monkey patch IText pour éviter que les textareas déplacent le scroll en prenant le focus
export default class CustomTextbox extends IText {
  _calcTextareaPosition() {
    if (!this.canvas) {
      return { left: '1px', top: '1px' };
    }
    const desiredPosition = this.inCompositionMode
      ? this.compositionStart
      : this.selectionStart,
      boundaries = this._getCursorBoundaries(desiredPosition),
      cursorLocation = this.get2DCursorLocation(desiredPosition),
      lineIndex = cursorLocation.lineIndex,
      charIndex = cursorLocation.charIndex,
      charHeight =
        this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize') *
        this.lineHeight,
      leftOffset = boundaries.leftOffset,
      retinaScaling = this.getCanvasRetinaScaling(),
      upperCanvas = this.canvas.upperCanvasEl,
      upperCanvasWidth = upperCanvas.width / retinaScaling,
      upperCanvasHeight = upperCanvas.height / retinaScaling,
      maxWidth = upperCanvasWidth - charHeight,
      maxHeight = upperCanvasHeight - charHeight;

    const p = new Point(
      boundaries.left + leftOffset,
      boundaries.top + boundaries.topOffset + charHeight,
    )
      .transform(this.calcTransformMatrix())
      .transform(this.canvas.viewportTransform)
      .multiply(
        new Point(
          upperCanvas.clientWidth / upperCanvasWidth,
          upperCanvas.clientHeight / upperCanvasHeight,
        ),
      );

    // Ci-dessous le code de IText de base 

    // if (p.x < 0) {
    //   p.x = 0;
    // }
    // if (p.x > maxWidth) {
    //   p.x = maxWidth;
    // }
    // if (p.y < 0) {
    //   p.y = 0;
    // }
    // if (p.y > maxHeight) {
    //   p.y = maxHeight;
    // }

    // // add canvas offset on document
    // p.x += this.canvas._offset.left;
    // p.y += this.canvas._offset.top;

    // Ci-dessous notre version radicale
    p.y = 0
    p.x = 0

    return {
      left: `${p.x}px`,
      top: `${p.y}px`,
      fontSize: `${charHeight}px`,
      charHeight: charHeight,
    };
  }
}
